import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './app/environment';

if (environment) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
